export default __webpack_public_path__ + "507355b6cc1eae90999d34e85d0c926e.png";